import { getProducts } from "@/utils/apis/order-service";
import { ProductType } from "@/utils/enums/ProductType";
import { useAuthStore } from "@/utils/stores/useAuthStore";
import { useProductsStore } from "@/utils/stores/useProductsStore";
import { useCallback, useState } from "react";

export const useGetProducts = () => {
    const { auth } = useAuthStore();
    const { updateProductsData } = useProductsStore();
    const [isLoading, setIsLoading] = useState(false);

    const fetchProducts = useCallback(async () => {
        const { idToken, userId } = auth;

        if (!idToken || !userId) return;

        try {
            setIsLoading(true);
            const products = await getProducts(userId, idToken);

            if (products) {
                products.forEach((product) => {
                    if (product.product_type === ProductType.DnaTest) {
                        updateProductsData({ dnaTest: product.data.channel });
                    }
                    if (product.product_type === ProductType.MetabolicHook) {
                        updateProductsData({ metabolicHook: true });
                    }
                });
            }

            return products;
        } catch (error) {
            console.error("Error fetching products:", error);
        } finally {
            setIsLoading(false);
        }
    }, [auth, updateProductsData]);

    return {
        fetchProducts,
        isLoading,
    };
}